import { observable, action, runInAction } from 'mobx';
import { isEmpty, cloneDeep } from 'lodash';

import EffectService from '@service/effect';
import moSingle, {
  singleInit,
} from '../component/single-industry/store/index';
import moMulti, {
  multiInit,
} from '../component/multi-industry/store/index';
import moSample, {
  sampleInit, sampleUpdate,
} from '../component/company-sample/store/index';
import { effectInit } from './index';

const moMenu = observable({
  vipTip: false,
  industry: { code: '', name: '' },
  uuid: '',
  industryName: '',
  compareList: <any[]>[],
  minStaff: 0,
  maxStaff: 0,
  staffIndustryNumber: 0,
  staffTrendNumber: 0,
  chooseCompany: <any[]>[],
  companyFilter: <any[]>[],
  filterLength: 0,
});

const menuInit = action(async (init = true, onlyMulti = false) => {
  const res: any = await EffectService.getUserOption();
  console.log('用户筛选项 -- ', init, ' --- ', res);
  if (isEmpty(res)) return;
  runInAction(() => {
    moMenu.uuid = res.user_uuid;
    moMenu.industryName = res.my_industry || '';
    moMenu.compareList = res.multi_industries || [];
    moMenu.chooseCompany = res.companies || [];
    moMenu.companyFilter = res.companies || [];
    moMenu.filterLength = res.companies?.length || 0;
    moMenu.minStaff = res.company_filter?.min_staff || 0;
    moMenu.maxStaff = res.company_filter?.max_staff || 0;
    moMenu.staffIndustryNumber = res.staff_num_multi_industry || 0;
    moMenu.staffTrendNumber = res.staff_num_year_trend || 0;

    if (init) {
      singleInit();
      multiInit();
      console.log(88888);
      sampleUpdate(moMenu.industryName, moMenu.chooseCompany);
    }
    if (onlyMulti) multiInit();
  });
});

const updateCompanyFilter = action((arr: any[]) => {
  let len = 0;
  arr.map((item: any) => {
    if (item.active) len += 1;
  });
  moMenu.companyFilter = arr;
  moMenu.filterLength = len;
});

const resetCompanyFilter = action(() => {
  let len = 0;
  moMenu.chooseCompany.map((item: any) => {
    if (item.active) len += 1;
  });
  moMenu.companyFilter = moMenu.chooseCompany;
  moMenu.filterLength = len;
});

const updateChooseCompany = action(async (arr: any, init = false) => {
  const companyNames: any[] = arr.map((item: any) => item.company_name);

  const res: any = await EffectService.editUserOption({ companies: companyNames });
  runInAction(() => {
    moMenu.chooseCompany = arr;
    if (init) effectInit(false);
  });
});

const setChooseCompany = action((arr: any) => {
  moMenu.chooseCompany = arr;
});

const toggleTip = action((value: boolean) => {
  moMenu.vipTip = value;
});

export default moMenu;
export {
  menuInit, toggleTip, updateCompanyFilter, resetCompanyFilter,
  updateChooseCompany, setChooseCompany,
};
